import { useParams, Link, Navigate } from "react-router-dom";
import { getPostBySlug, formatBlogDate } from "../lib/blog";
import { useSeoMeta, SITE_URL, PUBLISHER_NAME } from "../lib/seo";

export default function BlogPost() {
  const { slug = "" } = useParams();
  const post = getPostBySlug(slug);

  useSeoMeta({
    title: post ? post.title : "Not found",
    description: post?.description,
    path: `/blog/${slug}`,
    type: "article",
    image: post?.image,
    publishedTime: post?.date,
    jsonLd: post
      ? {
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          headline: post.title,
          description: post.description,
          datePublished: post.date,
          dateModified: post.date,
          author: { "@type": "Organization", name: PUBLISHER_NAME },
          publisher: { "@type": "Organization", name: PUBLISHER_NAME, url: SITE_URL },
          mainEntityOfPage: { "@type": "WebPage", "@id": `${SITE_URL}/blog/${slug}` },
          ...(post.image ? { image: [post.image] } : {}),
        }
      : undefined,
  });

  if (!post) return <Navigate to="/blog" replace />;

  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <Link to="/blog" className="text-sm text-ledger-400">
        ← Back to blog
      </Link>
      <p className="mt-4 text-xs text-muted font-mono">{formatBlogDate(post.date)}</p>
      <h1 className="mt-1 font-display text-3xl leading-tight">{post.title}</h1>

      {post.image && (
        <figure className="mt-6">
          {/* eslint-disable-next-line jsx-a11y/alt-text -- alt comes from frontmatter, may legitimately be empty */}
          <img src={post.image} alt={post.imageAlt ?? ""} className="w-full rounded-lg" loading="lazy" />
          {post.imageAttribution && (
            <figcaption className="mt-2 text-xs text-muted">{post.imageAttribution}</figcaption>
          )}
        </figure>
      )}

      {/* post.html is compiled from this repo's own markdown files (src/content/blog/), never user input. */}
      <div className="prose mt-8" dangerouslySetInnerHTML={{ __html: post.html }} />
    </div>
  );
}
